import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Button from '../Button/index.js';

const {
  string,
  bool,
  oneOf
} = PropTypes;
function ButtonIcon({
  category,
  className,
  name,
  size,
  spinner,
  variant,
  iconClassName,
  ...props
}) {
  const iconProps = spinner ? {} : {
    iconCategory: category,
    iconName: name,
    iconSize: size,
    iconVariant: variant,
    iconClassName: cx("tds-button__icon", {
      "tds-button__icon_custom": category !== "utility"
    }, iconClassName),
    variant: "icon"
  };
  return /*#__PURE__*/React.createElement(Button, Object.assign({}, props, iconProps, {
    className: cx("slds-button_icon tds-button_icon", className, `tds-button_icon-${size}`, {
      "slds-button_icon-border-filled": variant === "border-filled"
    }),
    spinner: spinner
  }));
}
ButtonIcon.displayName = "ButtonIcon";
ButtonIcon.defaultProps = {
  category: "utility",
  className: null,
  disabled: false,
  name: null,
  size: "medium",
  variant: "border-filled",
  iconClassName: null,
  spinner: false
};
ButtonIcon.propTypes = {
  /**
   * Icon Category per SLDS.
   */
  category: oneOf(["utility", "custom", "action"]),
  /**
   * CSS class applied to the `button` element.
   */
  className: string,
  /**
   * To disable the button.
   */
  disabled: bool,
  /**
   * Icon Name per SLDS.
   */
  name: string,
  /**
   * Icon Size per SLDS.
   */
  size: oneOf(["small", "medium", "large"]),
  /**
   * Icon variant.
   */
  variant: oneOf(["border-filled", "icon", "bare"]),
  /**
   * CSS class name applied to icon. Does not apply when using the `spinner` prop.
   */
  iconClassName: string,
  /**
   * Spinner variant.
   */
  spinner: bool
};

export { ButtonIcon as default };
